import type { Critter } from "./dna";
import { drawCritterSprite } from "../sprites/creatures";

/** Draw a wild critter — PNG body art when loaded, else chibi fallback. */
export function drawCritter(
  ctx: CanvasRenderingContext2D,
  c: Critter,
  opts?: { seatX?: number; seatY?: number },
): void {
  drawCritterSprite(ctx, c, opts);
}
